import * as React from "react";
import { PlasmicMembership } from "./plasmic/blank_website_mobile_first/PlasmicMembership";
import {AppStore} from "../useAppPullState";
import {useLogout} from "./hooks/useLogout";

const getPaidYear = (user) => {
  try{
    const year =  Number(user?.paidDate?.split('.')[2]);
    if(isNaN(year)){
      return new Date().getFullYear();
    }
    return year;
  }catch (e){
  }

  return 2023;
}

const useProps = (props) => {
  const user = AppStore.useState(s => s.user)
  const userNumber = user ? user?.SgsMemberId : "initial";
  const userName = user ? user?.firstName + " " + user?.LastName : ""
  const logout = useLogout();
  const year = new Date().getFullYear();
  const paidYear = getPaidYear(user);

  return {
    style: {
      position: 'relative',
      zIndex: 90,
    },

    name: {
      children: userName,
    },
    number: {
        children: userNumber
    },
    nextYearPaid: paidYear === year,
    submit: {
      onClick(){
        AppStore.update(s => {
          s.showMembership = false;
        })
      }
    },
    logout: {
      onClick: logout
    },
    ...props,
  }
}
function Membership_(props, ref) {

  return <PlasmicMembership root={{ ref }} {...useProps(props)} />;
}

const Membership = React.forwardRef(Membership_);

export default Membership;
